import React from "react";

export const NoData = ({ message, icon = "fa-file-text-o", iconSize = 100, iconColor = "#e0e4ed", iconColorDark = "#343a46" }) => {
  return (
    <div
      className="p-5 pb-5 text-center rounded"
      style={{ boxShadow: "rgba(0, 0, 0, 0.05) 0px 0px 0px 1px" }}
    >
      <i
        style={{ fontSize: iconSize, color: iconColor }}
        className={`for-light fa ${icon} pb-2`}
      ></i>
      <i
        style={{ fontSize: iconSize, color: iconColorDark }}
        className={`for-dark fa ${icon} pb-2`}
      ></i>
      <p className="m-0" style={{ color: "#6c757d" }}>
        {message}
      </p>
    </div>
  );
};
